import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {config} from "../../../../environments/config";
import {Transferencias} from "../../_model/index";
import { UsuarioService } from '../usuario/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class TransferenciasService {

  constructor(private http: HttpClient,
              private user: UsuarioService) { }


    NCinterna(formdata) {
        const params = new HttpParams()
            .set('token', this.user.getToken().dataset.token)
            .set('producto', formdata.producto)
            .set('cuenta', formdata.cuenta)
            .set('monto', formdata.monto)
            .set('productosocio', formdata.productosocio)
            .set('cuentasocio', formdata.cuentasocio)
            .set('descripcion', formdata.descripcion);
        return this.http.post<any>(`${config.apiUrl}/socio/transacciones/nctransferencia`, params)
            .toPromise()
            .then(res => <any>res.data)
            .then(data => {
                return data;
            });
    }
    NCInterbancaria(formdata) {
        const params = new HttpParams()
            .set('token', this.user.getToken().dataset.token)
            .set('monto', formdata.monto)
            .set('producto', formdata.producto)
            .set('cuenta', formdata.cuenta)
            .set('banco', formdata.cuentabanco)
            .set('identificacion', formdata.identificacion)
            .set('beneficiario', formdata.beneficiario)
            .set('tipocuenta', formdata.tipocuenta)
            .set('ctaacreditar', formdata.cuentaacreditar)
            .set('descripcion', formdata.descripcion)
            .set('spiconcepto', formdata.concepto)
            .set('tipocuentaacreditar', formdata.tipocuentaacreditar);
        return this.http.post<any>(`${config.apiUrl}/spi/create`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            });
    }
}
